/*
 *
 * CheckoutPage actions
 *
 */

import { action, createAsyncAction } from 'typesafe-actions';

import ActionTypes from './constants';

export const defaultAction = () => action(ActionTypes.DEFAULT_ACTION);
export const goToStep = (data: any) => action(ActionTypes.GO_TO_STEP, data);
export const setCheckout = (data: any) => action(ActionTypes.SET_CHECKOUT, data);
export const setCheckoutTotal = (data: any) => action(ActionTypes.SET_CHECKOUT_TOTAL, data);
export const setCheckoutStatus = (data: any) => action(ActionTypes.SET_CHECKOUT_STATUS, data);
export const checkoutCart = () => action(ActionTypes.CHECKOUT_CART);
export const setSomethingChanged = () => action(ActionTypes.SOMETHING_CHANGED);
export const checkout = createAsyncAction(
  ActionTypes.CHECKOUT_CART_REQUEST,
  ActionTypes.CHECKOUT_CART_SUCCESS,
  ActionTypes.CHECKOUT_CART_FAILURE,
)<void, {}, void>();
export const trackOrdersCompletedById = (data: any) => action(ActionTypes.TRACK_ORDERS_COMPLETED, data);
export const createOrderDraft = () => action(ActionTypes.CREATE_ORDER_DRAFT);
export const orderDraft = createAsyncAction(
  ActionTypes.CREATE_ORDER_DRAFT_REQUEST,
  ActionTypes.CREATE_ORDER_DRAFT_SUCCESS,
  ActionTypes.CREATE_ORDER_DRAFT_FAILURE,
)<void, {}, Error>();
export const setOpenConfirmSameDayDeliveryModal = (data) =>
  action(ActionTypes.SET_OPEN_CONFIRM_SAME_DAY_DELIVERY_MODAL, data);

export const applyVoucher = (data: any) => action(ActionTypes.APPLY_VOUCHER, data);
export const calculateVoucher = createAsyncAction(
  ActionTypes.CALCULATE_VOUCHER_REQUEST,
  ActionTypes.CALCULATE_VOUCHER_SUCCESS,
  ActionTypes.CALCULATE_VOUCHER_FAILURE,
)<void, {}, Error>();
export const searchVoucher = (data: string) => action(ActionTypes.SEARCH_VOUCHER, data);
export const getVouchers = (data: any) => action(ActionTypes.GET_VOUCHER, data);
export const voucher = createAsyncAction(
  ActionTypes.GET_VOUCHER_REQUEST,
  ActionTypes.GET_VOUCHER_SUCCESS,
  ActionTypes.GET_VOUCHER_FAILURE,
)<void, {}, Error>();
